import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Star, Quote } from "lucide-react";

export const TimelyTestimonials = () => {
  const testimonials = [
    {
      name: "Rajesh Kumar",
      role: "Car Owner",
      location: "Delhi",
      rating: 5,
      text: "Timelyyy has made car washing so convenient! I can book a slot while at work and pick up my car on the way home. The WhatsApp updates keep me informed throughout the process.",
      avatar: "RK",
      color: "bg-gradient-to-br from-blue-500 to-indigo-500"
    },
    {
      name: "Priya Sharma",
      role: "Bike Owner", 
      location: "Mumbai",
      rating: 5,
      text: "As a working professional, I don't have time to wait at wash centers. Timelyyy's booking system saves me hours every week. The service quality is consistently excellent.",
      avatar: "PS",
      color: "bg-gradient-to-br from-green-500 to-emerald-500"
    },
    {
      name: "Amit Patel",
      role: "Wash Center Owner",
      location: "Ahmedabad",
      rating: 5,
      text: "Since joining Timelyyy, my business has grown by 40%. The platform brings in new customers and the WhatsApp integration makes communication seamless.",
      avatar: "AP",
      color: "bg-gradient-to-br from-purple-500 to-pink-500"
    },
    {
      name: "Sneha Reddy",
      role: "SUV Owner",
      location: "Bangalore",
      rating: 5,
      text: "The variety of wash centers and services available is impressive. I can always find a center near my location with availability. The digital invoices are a bonus!",
      avatar: "SR",
      color: "bg-gradient-to-br from-orange-500 to-red-500"
    },
    {
      name: "Vikram Singh",
      role: "Wash Center Owner",
      location: "Pune",
      rating: 5,
      text: "The analytics dashboard helps me understand my business better. Customer reviews and ratings have improved my service quality. Highly recommend to other wash centers.",
      avatar: "VS",
      color: "bg-gradient-to-br from-indigo-500 to-purple-500"
    },
    {
      name: "Anita Joshi",
      role: "Car Owner",
      location: "Chennai",
      rating: 5,
      text: "The payment system is secure and convenient. I love that I can pay through multiple options. The real-time updates on WhatsApp keep me informed about my booking status.",
      avatar: "AJ",
      color: "bg-gradient-to-br from-teal-500 to-cyan-500"
    }
  ];

  return (
    <div className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <Badge variant="secondary" className="bg-gradient-to-r from-green-100 to-emerald-100 text-green-800 border-green-200 mb-4 sm:mb-6 px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-medium">
            <Star className="w-3 h-3 sm:w-4 sm:h-4 mr-1.5 sm:mr-2" />
            Customer Stories
          </Badge>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 lg:mb-8 leading-tight px-2">
            What Our Customers Say
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed px-2">
            Join thousands of satisfied customers and wash center owners who trust Timelyyy for their vehicle wash needs and business growth.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="group hover:shadow-2xl transition-all duration-500 border-0 bg-white/80 backdrop-blur-sm hover:bg-white/90 transform hover:-translate-y-2">
              <CardContent className="p-5 sm:p-6 lg:p-8">
                <div className="flex items-start space-x-3 sm:space-x-4 mb-4 sm:mb-6">
                  <div className={`w-12 h-12 sm:w-14 sm:h-14 ${testimonial.color} rounded-xl sm:rounded-2xl flex items-center justify-center text-white font-bold text-base sm:text-lg shadow-lg group-hover:scale-110 transition-transform duration-300 flex-shrink-0`}>
                    {testimonial.avatar}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-bold text-gray-900 text-base sm:text-lg truncate">{testimonial.name}</h4>
                    <p className="text-xs sm:text-sm text-gray-600 font-medium truncate">{testimonial.role}</p>
                    <p className="text-xs text-gray-500">{testimonial.location}</p>
                  </div>
                </div>
                
                <div className="flex items-center mb-3 sm:mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                
                <div className="relative">
                  <Quote className="w-6 h-6 sm:w-8 sm:h-8 text-gray-200 absolute -top-2 sm:-top-3 -left-2 sm:-left-3" />
                  <p className="text-gray-700 leading-relaxed pl-4 sm:pl-6 text-sm sm:text-base">
                    "{testimonial.text}"
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};
